import { Routes, Route } from 'react-router-dom'
import ProtectedRoute from '@/components/ProtectedRoute'
import AdminLayout from '@/components/AdminLayout'
import Login from '@/pages/Login'
import Dashboard from '@/pages/Dashboard'
import CourseList from '@/pages/courses/CourseList'
import CourseForm from '@/pages/courses/CourseForm'
import LessonList from '@/pages/courses/LessonList'
import LessonForm from '@/pages/courses/LessonForm'
import VideoList from '@/pages/videos/VideoList'
import VideoForm from '@/pages/videos/VideoForm'
import TeacherList from '@/pages/teachers/TeacherList'
import TeacherForm from '@/pages/teachers/TeacherForm'
import PostList from '@/pages/posts/PostList'
import UserList from '@/pages/users/UserList'
import HomeConfigPage from '@/pages/home/HomeConfig'
import PaymentList from '@/pages/payments/PaymentList'
import PaymentSettings from '@/pages/payments/PaymentSettings'
import CategorySettings from '@/pages/categories/CategorySettings'
import SystemUserList from '@/pages/system-users/SystemUserList'

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<ProtectedRoute />}>
        <Route element={<AdminLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="home-config" element={<HomeConfigPage />} />
          <Route path="courses" element={<CourseList />} />
          <Route path="courses/new" element={<CourseForm />} />
          <Route path="courses/:id/edit" element={<CourseForm />} />
          <Route path="courses/:id/lessons" element={<LessonList />} />
          <Route path="courses/:courseId/lessons/new" element={<LessonForm />} />
          <Route path="courses/:courseId/lessons/:id/edit" element={<LessonForm />} />
          <Route path="videos" element={<VideoList />} />
          <Route path="videos/new" element={<VideoForm />} />
          <Route path="videos/:id/edit" element={<VideoForm />} />
          <Route path="teachers" element={<TeacherList />} />
          <Route path="teachers/new" element={<TeacherForm />} />
          <Route path="teachers/:id/edit" element={<TeacherForm />} />
          <Route path="posts" element={<PostList />} />
          <Route path="users" element={<UserList />} />
          <Route path="payments" element={<PaymentList />} />
          <Route path="payment-settings" element={<PaymentSettings />} />
          <Route path="categories" element={<CategorySettings />} />
          <Route path="system-users" element={<SystemUserList />} />
        </Route>
      </Route>
    </Routes>
  )
}
